import Price from "components/Price/Price"
import { Col, Row } from "elemental-react16"
import { Button, Card, Icon, Modal, Segment, Image, Message,Table, Progress } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { observer } from "mobx-react"
import React, { Component, Fragment } from "react"
import shop from "shop/shop"
import _ from "lodash"
import moment from "moment"
import "moment/locale/de"
import CostCentres  from "components/CostCentres/CostCentres";
import AccountReset from "components/Account/AccountReset"
import swal from "sweetalert"
import OrderModel from "../../../shop/OrderModel";
import { Redirect } from "react-router"
import NewCustomerContactPage from "./NewCustomerContactPage"
import MediaQuery from "react-responsive"
import languageStore               from "stores/languageStore"


const setPasswordAsAdmin = ( account ) => {

  swal( {
      text            : "Passwort setzen",
      type            : "prompt",
      title           : "Neues Passwort",
      showCancelButton: true,
      closeOnConfirm  : false,
      closeOnCancel   : true,
    },
    newPassword => {
      if ( !newPassword ) return
      shop.fetch( `/shop/rest/security/user/${account.userid}/logins?passupdate=1`, {
        method: "POST",
        body  : JSON.stringify( {
          ...account,
          "password": newPassword,
          "newpass" : newPassword,
          "repeat"  : newPassword
        } )
      } )
        .then( res => {
          console.log( "PW CHANGE", res )
          swal( translate( "reset.success" ),
            translate( "Passwort erfolgreich gesetzt." ),
            "success" )
        } )
        .catch( err => {
          console.error( err )
          swal( "Fehler", "Leider konnte IhrPasswort nicht geändert werden", "error" )
        } )

    }
  )
}

export function fetchExtraOrderRessources( order ) {
  return shop.fetch( `/shop/rest/data/customer/current/extrainfo?start=0&count=50&subref=${order.map_id}` )
    .then( res => {
      order.extrainfo = res.map( data => new OrderPDF( data ) )
      return new OrderModel(order)
    } )
}


class Accounts extends React.Component {

  state = {
    loading : false,
    accounts: [],
    user: false,
  }

  async componentDidMount() {
    this.setState( { loading: true } )

    const users    = await shop.fetch( `/shop/rest/users/data?start=0&count=100&filter=%7B%22customer_id%22%3A%22${shop.session.value.map_id}%22%7D`)

    var temp;
    if (users.length > 0) {
      this.user = users[0];
      temp = await shop.fetch( `/shop/rest/security/user/${users[0].id}/logins` )
    } else {
      temp = [];
    }

    const accounts = temp;
    console.log( { accounts } )
    this.setState( { accounts, loading: false } )
  }

  render() {
    const { accounts } = this.state
    return <div>
      <Segment.Group>
        {accounts.map( account => {
          return <Segment clearing key={account.login}>
            <Button floated={"right"} onClick={() => setPasswordAsAdmin( account )}>{translate( "change Password" )}</Button>
            <div className="pa2 b">{account.login} {account.contact}</div>
          </Segment>
        } )}
      </Segment.Group>
    </div>
  }
}

export const orderTypes = {
  0: "Order",
  1: "Delivery",
  2: "Invoice",
}

class OrderPDF {
  constructor( order ) {
    Object.assign( this, order )
    this.typeName = orderTypes[ order.type ] || "Unknown"
    this.url = `${shop.config.BASE}/shop/rest/data/customer/current/extraresources/` + encodeURIComponent(order.map_id)
  }
}

@observer
export default class AccountPage extends Component {

  state = {
    session        : shop.session || {}, locations: [],
    orders         : [],
    current        : 0,
    showAddressBook: false,
    noMoreOrders   : false,
    frachtkosten: true,
    openTab: "dashboard",
    loadFullHistory: false,
  }

  loadMore = () => {
    let { orders, current } = this.state
    let pageSize = 250
    let start = current
    current = current + pageSize
    this.setState( { loading: true } )
    shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
      .then( async res => {
        let extras = res.values.map( order => fetchExtraOrderRessources( order ) )
        await Promise.all( extras )
        console.log( "FROM API", { res } )
        orders = orders.concat( res.values )
        this.setState( { loading: false, current, orders } )
        if ( res.values.length === 0 ) {
          this.setState( { noMoreOrders: true, current, orders } )
        }
      } )
  }

  loadSession = ( session ) => {
    this.loadMore()
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        this.setState( { locations } )
      } )
  }

  componentDidMount() {
    shop.events.authentified.add( this.loadSession )
    // this.loadSession()Top
    console.log("this.props", this.props, this.props.location.search)
    if(this.props.location.search.includes("_order")){
      this.setState({ openTab: "order" });
    }
    if(this.props.location.search.includes("_address")){
      this.setState({ openTab: "address" });
    }
    if(this.props.location.search.includes("_contact")){
      this.setState({ openTab: "contact" });
    }
    if(this.props.location.search.includes("_frameworkAgreement")){
      this.setState({ openTab: "frameworkAgreement" });
    }

  }

  componentWillUnmount() {
    shop.events.authentified.remove( this.loadSession )
  }

  	handleTabButtons = (name ) => {
      this.setState({ openTab: name });
	}

  render() {
    let { locations, loading, noMoreOrders, orders,frachtkosten, openTab, loadFullHistory } = this.state
    let billingAddress = shop.session.value
    let shortlist = locations.slice( 0, 100 )
    console.log("this.props", this.props, this.props.location.search)

    if ( !shop.session ) return <Redirect to={"/"}/>
    if ( !shop.session.value ) return <Redirect to={"/"}/>
    if ( !shop.session.value.extras ) return <Redirect to={"/"}/>
    console.log("location0",locations[0])
    const note = shop.config.showNote && shop.session.value.extras[ "ts-note" ]
    if(shop.session.value.extras){
      if(shop.session.value.extras.mainlink){
        if(!locations){
          locations = [];
        }
        if(locations.length == 0 && shop.session.value.extras.mainlink != 'yes'){
          locations[0] = [];
          locations[0].mapid = shop.session.value.extras.mainlink; 
          if(shop.session.value.extras.linkcountry){ locations[0].country = shop.session.value.country; }
          if(shop.session.value.extras.linkstreet){ locations[0].street = shop.session.value.street; }
          if(shop.session.value.extras.linktitle){ locations[0].name1 = shop.session.value.title; }
          if(shop.session.value.extras.linkpcode){ locations[0].pcode = shop.session.value.pcode; }
          if(shop.session.value.extras.linkcity){ locations[0].city = shop.session.value.city; }
        }
      }
    }
    console.log("location0POST",frachtkosten)
    
    let locationsOnDisplay = _.map( shortlist, ( location, key ) => {
      // Group locations into rows of 3
      // If desktop, split in 3; if mobile, split in 2
      const isMobile = window.innerWidth <= 767;
      // For desktop, group by 3; for mobile, group by 2
      const groupSize = isMobile ? 1 : 3;
      if (key % groupSize === 0) {
        const rowLocations = shortlist.slice(key, key + groupSize);
        return (<Fragment key={key}>
          <MediaQuery minWidth={768}>
                                <Table key={key} className="accountTableHistory mb3">
        <colgroup>
          <col width="33%" />
          <col width="33%" />
          <col width="34%" />
        </colgroup>
        <tbody>
          <tr>
            {rowLocations.map((loc, idx) => (
          <td className="tl" key={idx}>
            <div className=" pa3 ba b--dashed bw2 b--black-30 ma2 tl" sm="1" style={{ minHeight: "200px" }}>
            <div className="pt3 b black-60">{translate("Lieferadresse")}</div>
            <Address location={loc} />
            </div>
          </td>
            ))}
            {/* Fill empty cells if less than 3 in last row */}
            {rowLocations.length < 3 &&
          Array.from({ length: 3 - rowLocations.length }).map((_, i) => (
            <td key={`empty-${i}`}>
              
            </td>
          ))}
          </tr>
        </tbody>
          </Table>
            </MediaQuery>
          <MediaQuery maxWidth={767}>
            <Fragment className="tc" key={key}>
            {rowLocations.map((loc, idx) => (
          <Fragment className="tc" key={idx}>
            <div className=" pa3 ba b--dashed bw2 b--black-30 ma3 tl flex flex-column justify-between" >
            <div className="pt3 b black-60">{translate("Lieferadresse")}</div>
            <Address location={loc} />
            </div>
          </Fragment>
            ))}
            </Fragment>
            </MediaQuery>

        </Fragment>

        );
      }
      return null;
    } )

    return (<Fragment>
        <div className="accountPageHeader">
          <div  className="container pt4 ">
            {/*<p className="fw6 f4 black-50">{translate( "My Account" )}</p> */}
            <MediaQuery minWidth={768}>
                          <Table className="accountTablePW" >
              <tbody>
              <tr>
                <td className="tl">
                  <p className="fw7 f2">{shop.session.value.title}</p>
                </td>
                <td className="tr">
                  {/*<div className="tr"><AccountReset email={shop.session.value.email}/></div> */}
                </td>
              </tr>
              <tr>
                <td className="tl">
                  <p className="fw7 f3">{translate( "Kundennummer" )}: {shop.session.value.map_id}</p>
                </td>
                <td className="tr">
                  <div className="tr"><AccountReset email={shop.session.value.email}/></div>
                </td>
              </tr>
              </tbody>
            </Table>
              </MediaQuery>
              <MediaQuery maxWidth={767}>
                <div className="flex flex-column items-start">
                  <div className="pb2"><p className="fw7 f3">{shop.session.value.title}</p></div>
                  <div className="pb3 pt2">
                    <p className="fw7 f4">{translate( "Kundennummer" )}: {shop.session.value.map_id}</p>
                  </div>
                  <div className="pb4 pt2"><AccountReset email={shop.session.value.email}/> </div>
                </div>
                </MediaQuery>
            <div className="flex flex-row justify-start w-100" 
                                      style={{
                          overflowX: "auto",
                          WebkitOverflowScrolling: "touch",
                          whiteSpace: "nowrap",
                          msOverflowStyle: "none",
                          scrollbarWidth: "none",
                          }} >
							<div className="pl2 pb2" style={{borderBottom: `${openTab == "dashboard" ? "2px solid #6fad1e" : "2px solid rgb(201, 201, 201)"}`}}>
							<button  className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "dashboard" ? "none" : "none"}`, 
								backgroundColor: `#f3f0e7`, }} onClick={() => this.handleTabButtons("dashboard")}><span className="pa2 fw7 f4">{translate("Dashboard")}</span></button></div>
								<div className=" pb2" style={{borderBottom: `${openTab == "address" ? "2px solid #6fad1e" : "2px solid rgb(201, 201, 201)"}`}}>
							<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "address" ? "none" : "none"}`, 
								backgroundColor: `#f3f0e7`, }} onClick={() => this.handleTabButtons("address")}><span className="pa2 fw7 f4">{translate("Adressen")}</span></button></div>
                <div className=" pb2" style={{borderBottom: `${openTab == "order" ? "2px solid #6fad1e" : "2px solid rgb(201, 201, 201)"}`}}>
							<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "order" ? "none" : "none"}`, 
								backgroundColor: `#f3f0e7`, }} onClick={() => this.handleTabButtons("order")}><span className="pa2 fw7 f4">{translate("Bestellungen")}</span></button></div>
                
              {/*<div className=" pb2" style={{borderBottom: `${openTab == "frameworkAgreement" ? "2px solid #6fad1e" : "2px solid rgb(201, 201, 201)"}`}}>	
              						<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "frameworkAgreement" ? "none" : "none"}`, 
								backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("frameworkAgreement")}><span className="pa2 fw7 f4">{translate("Rahmenaufträge")}</span></button></div>
               */}
               <div className=" pb2" style={{borderBottom: `${openTab == "contact" ? "2px solid #6fad1e" : "2px solid rgb(201, 201, 201)"}`}}>
							<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "contact" ? "none" : "none"}`, 
								backgroundColor: `#f3f0e7`, }} onClick={() => this.handleTabButtons("contact")}><span className="pa2 fw7 f4">{translate("Ansprechpartner")}</span></button></div>
								<div className="w-100" style={{borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
						</div>

          </div>
        </div>
        <div className="accountPageBody">
          <div className="container pt4">
            {openTab == "dashboard" && <Fragment>
               <div className="pb3 pt3">
                <p className="f2 fw7"> {translate( "My Account" )}</p>
              </div>
              <p className="fw5 f4">{translate( "View your customer data and recent orders" )}</p>

              <div className="pb3 pt3">
                <p className="f3 fw7"> {translate( "Adressen" )}</p>
              </div>

              <section>
                <Adresses billingAddress={billingAddress} openTab={openTab}/>
              </section>

                <section className="mt4 pb5">
                <Row>
                  <Col sm="1">
                    <Table className="accountTableHistory" >
                    <tbody>
                    <tr>
                      <td className="tl">
                        <p className="fw7 f3 pb3 ">{translate( "Order History" )}</p>
                      </td>
                      <td className="tr">
                        <div className="tr">
                          <Button className="tc mb3" primary style={{width: "300px", borderRadius: "35px", height: "50px"}} onClick={() => this.handleTabButtons("order")}>
                            <p className="fw7">{translate( "Alle Bestellungen anzeigen" )}</p>
                          </Button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </Table>
                    {orders.length >= 0 && <OrderTable rahmenauftrag={false} orders={orders.slice(0, 3)}/>}
                    {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
                    {noMoreOrders && <div>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}

                  </Col>
                </Row>
              </section>
            </Fragment>}
            {openTab == "address" && <Fragment>
              <div className="pb3 pt3">
                <p className="f2 fw7"> {translate( "Adressen" )}</p>
              </div>
              <p className="fw5 f4">{translate( "OrderAddressHint" )}</p>

              <Adresses billingAddress={billingAddress} openTab={openTab}/>
              {shortlist.length > 0 &&  <div className="pb3 pt3">
                <p className="f2 fw7"> {translate( "Adressbuch" )}</p>
              </div>}
              {locationsOnDisplay}
              </Fragment>}

            {openTab == "order" && <Fragment>
                            <div className="pb3 pt3">
                <p className="f2 fw7"> {translate( "Bestellungen" )}</p>
              </div>
                    {orders.length >= 0 && <OrderTable rahmenauftrag={false} orders={!loadFullHistory ? orders.slice(0, 6) : orders}/>}
                    {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
                    {noMoreOrders && <div>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}
                    {!loadFullHistory && <div className="pt3 pb3 flex flex-row justify-center">
                      <Button className="tc mb3" primary style={{width: "300px", borderRadius: "35px", height: "50px", backgroundColor: "#E3E0CA", color: "black"}} onClick={() => {
                      this.setState({ loadFullHistory: true }); 
                    }}>
                      <p className="fw7">{translate( "Alle Bestellungen anzeigen" )}</p>  
                    </Button></div>}
              </Fragment>}
        {note && <React.Fragment>
          <div className="row-title tl">
            <h2>{translate( "Kundendaten" )}</h2>
          </div>
          <div className={"pre-line pb4"}>{note}</div>
        </React.Fragment>}


      { openTab == "contact" && <section className="pt4">
							<div className="pb3 pt3">
							  <p className="f2 fw7"> {translate( "Ihr persönlicher Ansprechpartner" )}</p>
							</div>
        <NewCustomerContactPage />

      </section> }

      {openTab == "frameworkAgreement" && <Fragment>
                      <div className="pb3 pt3">
          <p className="f2 fw7"> {translate( "Rahmenaufträge" )}</p>
        </div>
              {orders.length >= 0 && <OrderTable rahmenauftrag={true} orders={orders}/>}
              {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
              {noMoreOrders && <div>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}

        </Fragment>}
        {/* openTab == "frameworkAgreement" && <section className="mt4 pb4"> RAHMENAUFTRAG
        <h2>{translate("Rahmenaufträge")}</h2>
        <Table>
          <colgroup>
            <col width="10%"/>
            <col width="20%"/>
            <col width="20%"/>
            <col width="20%"/>
            <col width="20%"/>
            <col width="10%"/>
          </colgroup>
          <Table.Header className="bg-light-gray bb b--black-20">
            <td className="fw6 f5">{translate("Artikel")}</td>
            <td className="fw6 f5">&nbsp;</td>
            <td className="fw6 f5">{translate("RahmenAuftragsID")}</td>
            <td className="fw6 f5">{translate("Abgerufene Menge")}</td>
            <td className="fw6 f5">{translate("Zeitraum")}</td>
            <td className="fw6 f5">{translate("PDF Details")}</td> 
          </Table.Header>
          <tbody>
            <Fragment>
              <tr>
                <td>
                  <Link to={`/product/${10030}`}>
                    <img
                      className="db center"
                      style={{maxWidth: "35px",maxHeight: "35px", minWidth: "35px",minHeight: "35px", overflow: "hidden",objectFit: "contain"}}
                      src={"https://herenz.trend-soft.de/shop/rest/data/images/description/1011300/1?size=small"}
                      alt=""/>
                  </Link>
                </td>
                <td>Steristopfen 10</td>
                <td>123456789</td>
                <td>250/500</td>
                <td>01.04.2025 - 01.07.2025</td>
                <td>2500,00 EUR</td>
              </tr>
              <tr>
                <td colSpan="6" className="bb b--black-50">
                  <Progress percent={Number((250 / 500) * 100).toFixed(2)} progress="percent" color="green" />
                </td>
              </tr>
            </Fragment>
            <Fragment>
              <tr>
                <td>
                  <Link to={`/product/${10030}`}> {/*<Link to={`/product/${product.map_id}`}>  
                    <img
                      className="db center"
                      style={{maxWidth: "35px",maxHeight: "35px", minWidth: "35px",minHeight: "35px", overflow: "hidden",objectFit: "contain"}}
                      src={"https://herenz.trend-soft.de/shop/rest/data/images/description/1011300/1?size=small"}
                      alt=""/>
                  </Link>
                </td>
                <td>Steristopfen 15</td>
                <td>TESTRAHMENAUFTRAG</td>
                <td>137/1337</td>                
                <td>01.01.2025 - 01.01.2026</td>
                <td>3750,00 EUR</td>
              </tr>
              <tr>
                <td colSpan="6" className="">
                  <Progress percent={Number((137 / 1337) * 100).toFixed(2)} progress="percent" color="green" />
                </td>
              </tr>
            </Fragment>
          </tbody>
        </Table>
        
        </section> */}


        {/*<pre>Session: {JSON.stringify(session, null, 2)}</pre>*/}
        {/*<pre>Adressen:{JSON.stringify(this.state.locations, null, 2)}</pre>*/}
      </div>
        </div>
        
    </Fragment>

    )
  }
}

const Adresses = ( { billingAddress, openTab } ) => {

  return (
<Fragment>
  <MediaQuery minWidth={768}>
  <Table className="accountPageAddressTable" >
        <colgroup>
          <col width="50%"/>
          <col width="50%"/>
        </colgroup>
        <tbody>
        <tr>
          <td>
          <div className="ba b--dashed bw2 b--black-30 ma2 tl" sm="1" style={{ minHeight: "250px" }}>
            <div className="pa3">
              <span className="black-50">{translate( "Rechnungsadresse" )}</span>
              <div className="pt1 f5 fw6"><strong className="fw7">{billingAddress.title}</strong> <br/>
              {billingAddress.street} <br/>
              {billingAddress.pcode} {billingAddress.city}<br/>
              {billingAddress.country}<br/>
              {billingAddress.email && <div>{billingAddress.email}</div>}
              {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </div>
            </div>
          </div>
          </td>
          <td>
                     { openTab == "address" && <div className="ba b--dashed bw2 b--black-30 ma2" sm="1" style={{ minHeight: "250px" }}>
            <div className="pa3">
              <span className="black-50">{translate( "Lieferadresse" )}</span>
              <div className="pt1 f5 fw6"><strong className="fw7"> {billingAddress.title}</strong> <br/>
              {billingAddress.street} <br/>
              {billingAddress.pcode} {billingAddress.city}<br/>
              {billingAddress.country}<br/>
              {billingAddress.email && <div>{billingAddress.email}</div>}
              {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </div>
            </div>
          </div>}
          </td>   
          </tr>
          </tbody>
  </Table>
    </MediaQuery>
  <MediaQuery maxWidth={767}>
      <table className="accountPageAddressTable" >
        <colgroup>
          <col width="50%"/>
          <col width="50%"/>
        </colgroup>
        <tbody>
        <tr>
          <td>

          </td>
          <td>

          </td>   
          </tr>
          </tbody>
  </table>
            <div className="ba b--dashed bw2 b--black-30 ma2 tl" sm="1" style={{ minHeight: "250px" }}>
            <div className="pa3">
              <span className="black-50">{translate( "Rechnungsadresse" )}</span>
              <div className="pt1 f5 fw6"><strong className="fw7">{billingAddress.title}</strong> <br/>
              {billingAddress.street} <br/>
              {billingAddress.pcode} {billingAddress.city}<br/>
              {billingAddress.country}<br/>
              {billingAddress.email && <div>{billingAddress.email}</div>}
              {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </div>
            </div>
          </div>
                               { openTab == "address" && <div className="ba b--dashed bw2 b--black-30 ma2" sm="1" style={{ minHeight: "250px" }}>
            <div className="pa3">
              <span className="black-50">{translate( "Lieferadresse" )}</span>
              <div className="pt1 f5 fw6"><strong className="fw7"> {billingAddress.title}</strong> <br/>
              {billingAddress.street} <br/>
              {billingAddress.pcode} {billingAddress.city}<br/>
              {billingAddress.country}<br/>
              {billingAddress.email && <div>{billingAddress.email}</div>}
              {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </div>
            </div>
          </div>}
    </MediaQuery>

      </Fragment>
  )
}

const OrderTable = ( { orders, rahmenauftrag } ) => {
  if ( orders.length === 0 ) {
    return null
    // return (<p>Keine Bestellungen gefunden.</p>)
  }

  return (
    <Fragment>
      <MediaQuery minWidth={768}>
    <div className="table-scroller">
      <Table className={rahmenauftrag ? "orderTableAccountRahmen" : "orderTableAccount"} >
        <colgroup>
          <col width="20%"/>
          <col width="15%"/>
          <col width="15%"/>
          <col width="15%"/>
          <col width="20%"/>
          <col width="20%"/>
        </colgroup>

        <tbody>
        <tr>
          <th className="ttu"> {rahmenauftrag ? translate( "Rahmenauftragsnummer" ) : translate( "order number" )}</th>
          <th className="ttu tl">{rahmenauftrag ? translate( "Abrufbar bis" ) : translate( "Datum" )}</th>
          <th className="ttu tl">{translate( "price" )}</th>
          <th className="ttu tl">{translate( "positions" )}</th>
          <th className="ttu tl">{translate( "status" )}</th>
          <th className="ttu tl">&nbsp;</th>
        </tr>

        {orders.length > 0 && orders.map( ( order ) => <OrderPreviewRow rahmenauftrag={rahmenauftrag} key={order.id} order={order}/> )}
        </tbody>
      </Table>
    </div>
        </MediaQuery>
        <MediaQuery maxWidth={767}>
          <div>
          <table>
            <colgroup>
              <col width={rahmenauftrag ? "80%" : "70%"} />
              <col width="40%"/>
            </colgroup>
            <tbody>
              {orders.length > 0 && orders.map( ( order ) => <OrderPreviewRow rahmenauftrag={rahmenauftrag} key={order.id} order={order}/> )}

            </tbody>
          </table>
          </div>
        </MediaQuery>

    </Fragment>
  )
}

const OrderPreviewRow = ( { order, rahmenauftrag } ) => {
  const orderDate = rahmenauftrag ? moment( order.deliverdate ).format( "DD.MM.YYYY" ) : moment( order.register ).format( "DD.MM.YYYY" )
  console.log("order in row", order)
  const orderLink = `/account/orders/${order.map_id}`
  const isSuccess = (order.status === "2" || order.status === 2)
  let rahmenauftragStatus = rahmenauftrag && order.deliverdate && moment(order.deliverdate).isValid() && moment(order.deliverdate).isAfter(moment(), 'day')
    ? <span style={{ color: "#369678" }}>{translate("Aktiv")}</span>
    : <span style={{ color: "red" }}>{translate("Abgelaufen")}</span>;
  let orderstateCounter = 0
  let orderstate = 0
  let orderstateArray = ["Vollständig geliefert","Rückstand","Teilweise geliefert"];
  let maxArticle = 0;
  let usedArticle = 0;
  let rahmenauftragartikel = "";
  const { currentLanguage } = languageStore
  if(!rahmenauftrag && order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1"){
    console.log("rahmenauftrag", order)
    return null
  }
  else if (rahmenauftrag && order.extras && !order.extras.rahmenauftrag){
    return null
  }

  if(rahmenauftrag && order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1"){

    if (order.positions && Array.isArray(order.positions)) {
      order.positions.forEach(product => {
        console.log("product", product, product.count, product.open, product.unit_multi, product.open / product.unit_multi)
        maxArticle += Number(product.count) || 0;
        usedArticle += (Number(product.open) || 0) / (Number(product.unit_multi) || 1);
      });
    }
    console.log("maxArticle", maxArticle, " usedArticle", usedArticle)
  }
  
  for(let i = 0; order.positions.length > i; i++){
    
    /*if(order.positions[i].open != 0 && orderstate != 2){
      orderstate = 1
    }
    if(orderstate == 1 && order.positions[i].open == 0){
      orderstate = 2
    }*/
    if(order.positions[i].open != 0){
      orderstateCounter++
    }
    
    if(rahmenauftrag && order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1"){
      if (order.positions[i].article_nr) {
          rahmenauftragartikel = order.positions.map(
            (article) => (
              <div key={article.article_nr}>
                {console.log("article", article.article_nr)}
                {article.article_nr}
              </div>
            )
        );
      }
    }
    
    //console.log("order: ",order.map_id,"open: " ,order.positions[i].open," orderstate ",orderstate)
  }
  console.log("orderstatecounter: ", orderstateCounter, " order.length: ", order.positions.length)
  if(orderstateCounter == order.positions.length){
    orderstate = 1
  }
  if(orderstateCounter < order.positions.length){
    orderstate = 2
  }
  if(orderstateCounter == 0){
    orderstate = 0
  }
  console.log("order", order )

  return (
    <Fragment>
      <MediaQuery minWidth={768}>
        <tr>
          <td>
            <Link className="fw7 f5" style={{ color: "#369678" }} to={orderLink}>
              #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
            </Link>
          </td>
          <td className="tl">
            <div className="nowrap">{orderDate}</div>
          </td>
          <td className="tl"><Price>{order.netto}</Price></td>
          <td className={rahmenauftrag ? "tr" : "tl"}>{rahmenauftrag ? order.positions.length : order.positions.length}</td>
          <td className="tl">
            {rahmenauftrag ? rahmenauftragStatus : translate(orderstateArray[orderstate])}
          </td>
          <td className="tl">
            <Button
              style={{
                width: "250px",
                borderRadius: "35px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              primary
              as={Link}
              to={orderLink}
            >
              <p className="fw6 f5" style={{ textAlign: "center", margin: 0, width: "100%" }}>
                {rahmenauftrag ? translate("Rahmenauftrag ansehen") : translate("Bestellung ansehen")}
              </p>
            </Button>
            {order.extras && order.extras.tracking && !rahmenauftrag && <div className="product-inner fr pt3" >
              <Button 
              as="a"
              href={`//tracking.dpd.de/status/${currentLanguage == "de" ? "de_DE" : "en_US"}/parcel/${order.extras.tracking}`}
              style={{
                backgroundColor: "#b814b8",
                color: "white",
                width: "250px",
                borderRadius: "35px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }} primary><p className="fw6">{translate( "Sendungsverfolgung" )}</p></Button></div>}


          </td>
        </tr>
        {/*rahmenauftrag && order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1" && <tr ><td style={{border: "none"}} colSpan={6} className="pa2 endBorder">
                        {order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1" && rahmenauftrag && 
                      <Progress percent={Number((usedArticle / maxArticle) * 100).toFixed(2)} progress="percent" size="large" className="herenzprogress" />}
          </td></tr>*/}
      </MediaQuery>
      <MediaQuery maxWidth={767}>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{rahmenauftrag ? translate( "Rahmenauftragsnummer" ) : translate( "order number" )} </p>
          </td>
          <td className="tr pa2 fw7 f5">
            <Link className="fw7 f5" style={{ color: "#369678" }} to={orderLink}>
              #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
            </Link>
          </td>
        </tr>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{translate("date")}</p>
          </td>
          <td className="tr pa2 fw7 f5">
            <div className="nowrap">{orderDate}</div>
          </td>
        </tr>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{translate("price")}</p>
          </td>
          <td className="tr pa2 fw7 f5">
            <Price>{order.netto}</Price>
          </td>
        </tr>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{translate("positions")}</p>
          </td>
          <td className="tr pa2 fw7 f5">
            {order.positions.length}
          </td>
        </tr>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{translate("Status")}</p>
          </td>
          <td className="tr pa2 fw7 f5">
            {rahmenauftrag ? rahmenauftragStatus : translate(orderstateArray[orderstate])}
          </td>
        </tr>
        <tr>
          <td
            className="tr"
            colSpan={2}
            style={{
              borderBottom: "3px solid #369678",
              padding: "10px"
            }}
          >
            <Button
              style={{
                width: "100%",
                borderRadius: "35px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              primary
              as={Link}
              to={orderLink}
            >
              <p className="fw6 f5" style={{ textAlign: "center", margin: 0, width: "100%" }}>
                {rahmenauftrag ? translate("Rahmenauftrag ansehen") : translate("Bestellung ansehen")}
              </p>
            </Button>
            
            {order.extras && order.extras.tracking && !rahmenauftrag &&<Fragment><div className="pt2"></div>
              <Button 
              as="a"
              href={`//tracking.dpd.de/status/${currentLanguage == "de" ? "de_DE" : "en_US"}/parcel/${order.extras.tracking}`}
              style={{
                backgroundColor: "#b814b8",
                color: "white",
                width: "100%",
                borderRadius: "35px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }} primary><p className="fw6 f5" style={{ textAlign: "center", margin: 0, width: "100%" }}>{translate( "Sendungsverfolgung" )}</p></Button></Fragment>}

              {/*order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1" && rahmenauftrag && <div className="product-inner  pt2"  >
                      <Progress percent={Number((usedArticle / maxArticle) * 100).toFixed(2)} progress="percent" size="large" className="herenzprogress" /></div>*/}
          </td>
        </tr>
      </MediaQuery>
    </Fragment>
  )
}

const Address = ( { title, location } ) => {
  const isDeliveryAddress = location.mapid === (shop.cart.deliveraddress && shop.cart.deliveraddress.mapid)
  return (
    <React.Fragment>
      <div className="address-block pb3">
        <div className=""><strong>{location.name1} {location.name2} {location.name3}</strong></div>
        <div className="block"><strong>{location.company || <span className="black-40">&hellip;</span>}</strong>
          <br/>
          {location.street || <span className="black-40">&hellip;</span>}<br/>
          {location.pcode} {location.city || <span className="black-40">&hellip;</span>}<br/>
          {location.country || <span className="black-40">&hellip;</span>}<br/>
        </div>
        <div className="pt3">
          {/*<a onClick={() => {shop.cart.setAddress( { location } )}} className="black-40" href="#">als Lieferadresse</a> <br/>*/}
          {/*<a className="black-40" href="#">Änderung beantragen</a> <br/>*/}
          {/*<a className="black-40" href="#">löschen</a> <br/>*/}
        </div>
      </div>
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/theme/lucht-test/pages/AccountPage.js